import React from "react";
import { useEffect, useState, useRef } from "react";
import Storage from "@/app/core/util/Storage";
import DeliveryModal from "@/app/core/layouts/main-components/delivery/DeliveryModal";
import { Panel, Tab, Tabs } from "@bumaga/tabs";
import { DeliveryController } from "@/app/core/base/controllers/DeliveryController";
import DeliveryHelper from "@/app/core/util/helpers/DeliveryHelper";
import { DateTranslate } from "@/app/core/util/DateTranslater";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";

export default function DocumentsComponent() {
    const userData = Storage.getUserData();
    const [data, setData] = useState({});
    const [showModal, setShowModal] = useState(false);
    const [loading, setLoading] = useState(false);
    const [deliveryId, setDeliveryId] = useState("");

    useEffect(() => {
        loadDeliveries()
    }, []);

    async function loadDeliveries() {
        setLoading(true);
        await DeliveryController.Get(userData.id, 15, async res => {
            let inner = [];
            let outer = [];
            for (var s in res) {
                await DeliveryController.ListDocs(res[s].id, result => {
                    if (result != undefined && result != null) {
                        let base = result.data;
                        let docs = [];
                        for (let s in base.docs) {
                            const item = { ...base.docs[s], name: s };
                            docs.push(item);
                        }
                        res[s].files = docs;
                    }
                    if (res[s].carrierCode != null) {
                        outer.push(res[s]);
                    } else {
                        inner.push(res[s]);
                    }
                }, error => {
                    console.log("Não pegou arquivos", error);
                    if (res[s].carrierCode != null) {
                        outer.push(res[s]);
                    } else {
                        inner.push(res[s]);
                    }
                });

            }
            setData({ national: inner, international: outer });
            setLoading(false);
        });
    }

    return (
        <div className="content row mt-3">
            <div className="col-md-12">
                <h3 className="text-muted"><i className="fa fa-arrow-left mr-1" /> {Translate(Message.Menu.Documents)}</h3>
            </div>
            <Tabs>
                <div className="block block-fx-pop block-rounded col-12 row p-2">
                    <Tab>
                        <button className="btn btn-dual"><i className="fa fa-shipping-fast mr-1" /> {Translate(Message.NationalDelivery)}</button>
                    </Tab>
                    <Tab>
                        <button className="btn btn-dual"><i className="fa fa-ship mr-1" /> {Translate(Message.InternationalDelivery)}</button>
                    </Tab>
                </div>

                <div className="col-12">
                    {loading === true ? (
                        <div className="text-center">
                            <i className={"fa fa-circle-notch fa-spin fa-2x"}></i>
                        </div>
                    ) : ""}
                    <Panel>
                        <div>
                            {data && data.national && data.national.map(item => (
                                <a className={"block block-rounded block-link-shadow block-bordered border-info border-3x"} href="javascript:void(0)">
                                    <div className="block-header">
                                        <div className="block-title inline-block"><img src="assets/media/box.png" height={40} /> Cód: {item && item.id}
                                        </div>
                                        <div className="block-tools">
                                            {DeliveryHelper().Status(item.status)}
                                        </div>
                                    </div>
                                    <div className="block-content">
                                        <table className="table">
                                            <tbody>
                                                <tr>
                                                    <td><i className="si si-map" /> {Translate(Message.Origin)} {item && item.origin && `${item.origin.number}, ${item.origin.street}, ${item.origin.neighborhood} | ${item.origin.city} - ${item.origin.state}`}</td>
                                                    <td><i className="si si-map" /> {Translate(Message.Destination)} {item && item.destination && `${item.destination.number}, ${item.destination.street}, ${item.destination.neighborhood} | ${item.destination.city} - ${item.destination.state}`}</td>
                                                    <td><i className="si si-calendar" /> {Translate(Message.RequestDate)}: {DateTranslate(item.createdAt)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div className="row">
                                            <div className="col-12 block-header mb-0 pb-0">
                                                <div className="block-title">
                                                    <h2 className="content-heading font-w700">{Translate(Message.Menu.Documents)}</h2>
                                                </div>
                                            </div>
                                            {item.files && item.files.map(item => (
                                                <div className="block block-fx-pop block-bordered border-success mt-1 col-md-6">
                                                    <div className="block-header">
                                                        <div className="block-title">
                                                            <i className="far fa-file-pdf text-success mr-2" /> {item.name}
                                                        </div>
                                                        <div className="block-tools">
                                                            <a className="btn btn-hero-success btn-sm" href={item.url} target="_blank"><i className="si si-cloud-download mr-1" /> Download</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </a>
                            ))}
                        </div>
                    </Panel>
                    <Panel>
                        <div>
                            {data && data.international && data.international.map(item => (
                                <a className={"block block-rounded block-link-shadow block-bordered border-info border-3x"} href="javascript:void(0)">
                                    <div className="block-header">
                                        <div className="block-title inline-block"><img src="assets/media/box.png" height={40} /> Cód: {item && item.id}
                                        </div>
                                        <div className="block-tools">
                                            {DeliveryHelper().Status(item.status)}
                                        </div>
                                    </div>
                                    <div className="block-content">
                                        <table className="table">
                                            <tbody>
                                                <tr>
                                                    <td><i className="si si-map" /> {Translate(Message.Origin)} {item && item.origin && `${item.origin.number}, ${item.origin.street}, ${item.origin.neighborhood} | ${item.origin.city} - ${item.origin.state}`}</td>
                                                    <td><i className="si si-map" /> {Translate(Message.Destination)} {item && item.destination && `${item.destination.number}, ${item.destination.street}, ${item.destination.neighborhood} | ${item.destination.city} - ${item.destination.state}`}</td>
                                                    <td><i className="si si-calendar" /> {Translate(Message.RequestDate)}: {DateTranslate(item.createdAt)}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <div className="row">
                                            <div className="col-12 block-header mb-0 pb-0">
                                                <div className="block-title">
                                                    <h2 className="content-heading font-w700">{Translate(Message.Menu.Documents)}</h2>
                                                </div>
                                            </div>
                                            {item.files && item.files.map(item => (
                                                <div className="block block-fx-pop block-bordered border-success mt-1 col-md-6">
                                                    <div className="block-header">
                                                        <div className="block-title">
                                                            <i className="far fa-file-pdf text-success mr-2" /> {item.name}
                                                        </div>
                                                        <div className="block-tools">
                                                            <a className="btn btn-hero-success btn-sm" href={item.url} target="_blank"><i className="si si-cloud-download mr-1" /> Download</a>
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>
                                </a>
                            ))}
                        </div>
                    </Panel>
                </div>
            </Tabs>
            <DeliveryModal
                show={showModal}
                deliveryId={deliveryId}
                onHide={() => setShowModal(false)}
            />
        </div>
    )
}